import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faIR } from 'date-fns/locale';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { CohorteEnum } from 'src/app/modules/shared/enumeration/cohorte.enum';

interface AccesRapide {
  title: string;
  urgence: string;
  subtitle: string;
  link: string;
  icon: string;
}

@Component({
  selector: 'app-dash-board-sigui',
  templateUrl: './dash-board-sigui.component.html',
  styleUrls: ['./dash-board-sigui.component.css'],
})
export class DashBoardSiguiComponent implements OnInit {
  user: any;
  nom: any;
  profil: any;
  prenom: any;
  appels: any[] = [];
  submissions: any[] = [];
  actuelDate!: any;
  rolename!: any;
  roleBenin!: any;
  roles!: any;
  cohorte!: string;
  inCohorte: boolean;
  filteredAccesRapides: AccesRapide[];
  coursera_user: boolean = false;
  email!: string;
  gestionnaireBenin: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    this.inCohorte = false;
    this.filteredAccesRapides = [];
  }
  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.roles = JSON.parse(this.user).roles;
    this.roleBenin = JSON.parse(this.user).roles[0]?.roleName;
    this.coursera_user = this.roles.roleName == 'coursera_srudent';
    this.email = JSON.parse(this.user).email;
    this.testAccesBenin();
    this.cohorte = JSON.parse(
      this.user,
    ).beneficiaryCohortes[0]?.cohorte.cohorteName;
    this.inCohorte = this.isInCohorte(this.cohorte);
    // console.log('users board ', this.user);
    if (this.roles.length != 0) {
      this.rolename = JSON.parse(this.user).roles[0].roleName;
    } else {
      this.rolename = null;
    }
    this.filteredAccesRapides = this.inCohorte
      ? this.accesRapides.filter(
        (item: AccesRapide) => item.title != 'Gestion AMI',
      )
      : this.accesRapides.filter((item: AccesRapide) => {
        if (item.title == 'Scholarvox Skills' && this.rolename == 'ami') {
          return false;
        }
        if (item.title == 'Gestion AMI' && this.rolename == 'ami') {
          return true;
        }

        if (item.title === 'Gestion AMI' && this.rolename !== 'ami') {
          return false;
        }
        if (item.title == 'Activités mensuelles' && this.rolename !== 'ami') {
          return false;
        }
        if (item.title == 'Activités mensuelles' && this.rolename == 'ami') {
          return true;
        }
        if (item.title == 'Certificats Coursera' && this.coursera_user) {
          return true;
        }
        if (item.title == 'Certificats Coursera' && !this.coursera_user) {
          return false;
        }
        if (
          !this.coursera_user ||
          this.cohorte == 'SIG2412-FODE' ||
          this.cohorte == 'SIG2502-FODE' ||
          this.cohorte
        )
          return (
            item.link !== '/dashboard/agenda' &&
            item.link !== '/dashboard/lms/hometestqualification'
          );
        return item.link !== '/dashboard/lms/hometestqualification';
      });

    //// //console.log(JSON.parse(this.user).roles);

    this.actuelDate = new Date().getTime();

    this.nom = JSON.parse(this.user).lastname;
    this.prenom = JSON.parse(this.user).firstname;
    this.profil = JSON.parse(this.user).profile.id;

    // this.authService.getAllApplications().subscribe((response) => {
    //   this.submissions = response;
    //   console.log('les applications : ', response);

    //   response.filter((appel: any) => {
    //     if (new Date(appel.closeDate).getTime() > this.actuelDate) {
    //       this.appels.push(appel);
    //     }
    //   });

    //   this.authService
    //     .getMySubmissions(JSON.parse(this.user).iuf)
    //     .subscribe((Response) => {
    //       this.submissions = Response;
    //       this.appels = response;

    //       this.submissions.forEach((submission) => {
    //         this.appels = this.appels.filter(
    //           (appel) =>
    //             new Date(appel.closeDate).getTime() > this.actuelDate &&
    //             appel.id != submission.application.id
    //         );
    //       });
    //     });
    // });
  }

  testAccesBenin() {
    if (this.roleBenin === 'gestionnaire-fcc-benin') {
      this.gestionnaireBenin = true;
    }
  }

  accesRapides: AccesRapide[] = [
    {
      title: 'Mon SIGUI',
      urgence: '',
      subtitle: "Voir l'état de vos dossiers",
      link: '/dashboard/agenda',
      icon: `send.png`,
    },
    {
      title: 'Mon portfolio',
      urgence: '',
      subtitle: 'Voir les offres disponibles',
      link: '/dashboard/users/portfolio',
      icon: `iconContainer.png`,
    },
    {
      title: 'Activités mensuelles',
      urgence: '',
      subtitle: 'Voir les activités mensuelles',
      link: '/dashboard//ami/activiteami',
      icon: `calendar-check-01.png`,
    },

    {
      title: 'Tests de Qualification',
      urgence: '',
      subtitle: 'Cliquez ici pour faire les tests',
      link: '/dashboard/lms/hometestqualification',
      icon: 'graduation-hat-01.png',
    },
    {
      title: 'Certificats Coursera',
      urgence: '',
      subtitle: 'Voir les certificats professionnels',
      link: '',
      icon: 'book-open-01.png',
    },
    {
      title: 'Ajouter un élève',
      urgence: '',
      subtitle: 'Vous pouvez ajouter des élèves',
      link: '/dashboard/stemd/add-eleve',
      icon: 'add-plus-25.png',
    },
    // {
    //   title: 'Scholarvox Skills',
    //   urgence: '',
    //   subtitle: 'Voir les formations Scholarvox',
    //   link: '',
    //   icon: 'calendar-check-01.png',
    // },
    // {
    //   title: 'Mes documents',
    //   urgence: '',
    //   subtitle: 'Gérer vos documents',
    //   link: '/dashboard/documents',
    //   icon: 'user-01.png',
    // },
  ];

  progressBar: any = [
    {
      // title: 'Mon portfolio',
      // subtitle: 'Voir les offres disponibles',
      // link: '/dashboard/appels',
      icon: `Progress Bar.png`,
    },
  ];

  isInCohorte = (value: string): boolean =>
    Object.values(CohorteEnum).includes(value as CohorteEnum);
}
